import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	background: ${({ theme }) => theme.grayLight};
`;
export const Headerpart = styled.div`
	display: grid;
	grid-template-columns: 1fr 170px;
	-webkit-box-pack: start;
	justify-content: flex-start;
	-webkit-box-align: center;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0px;
`;

export const HeaderTitle = styled.h5`
	font-size: 1rem;
	font-weight: bold;
	margin: 0 0 0 0.4rem;
`;
export const AreaSelectAll = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;

	.MuiFormControlLabel-root {
		margin: 0 0.3rem 0 0;
	}
`;
export const RowPart = styled.div`
	display: grid;
	grid-template-columns: 100px minmax(45%, 1fr) 30px 50px;
	justify-content: flex-start;
	align-items: center;
	gap: 0.4rem;
	padding: 0.2rem 0;
	border-bottom: 1px solid ${({ theme }) => theme.grayDark};
	cursor: pointer;
	transition: background-color 0.3s;

	&:hover {
		background-color: ${({ theme }) => theme.grayLight};
	}

	.MuiFormControlLabel-root {
		margin: 0;
	}
`;
export const ImagePart = styled.img`
	width: 100%;
	max-width: 100px;
	height: 80px;
	object-fit: contain;
`;

export const AreaTitlePart = styled.div`
	display: flex;
	flex-direction: column;
	gap: 3px;
	min-width: 0;

	&&& {
		> div:first-child {
			padding-left: 6px;
		}

		.supplierInventoryPartName .partName .text-content {
			display: block;
			min-width: 0;
			max-width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.MuiFormControl-root {
			border-radius: 4px;
		}

		.MuiInputBase-root {
			border: 1px solid ${({ theme }) => theme.grayDark};
			padding-top: 0px;
			padding-bottom: 0px;
			padding-left: 2px;
		}
	}
`;

export const Quantity = styled.div`
	border: 1px solid ${({ theme }) => theme.pantone2726C};
	width: 30px;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 20%;
	margin: 0 auto;
`;
